module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_okunai_studio_plus_house-edf95e80b5866fe8fdbcd35ff47c226e.jpg";